import { GraphQLClient } from 'graphql-request';
import { configService } from '../config/config.service';
import { getSdk } from './graphql/generated/api-types';

const graphQLClient = new GraphQLClient(configService.env.BERACHAIN_API_URL, {
  headers: { ChainId: configService.network.chainId.toString() },
});

// getSdk creates a typed client that can be used to fetch data
export const api = getSdk(graphQLClient);
